import React from "react";
import {CheckIcon} from "@heroicons/react/solid";
import ButtonPrimary from "../../shared/Button/ButtonPrimary";
import ButtonSecondary from "../../shared/Button/ButtonSecondary";

export interface PricingItem {
    id: string,
    isPopular: boolean;
    name: string;
    pricing: string;
    desc: string;
    per: string;
    features: string[];
}
const pricings: PricingItem[] = [
    {
        id: 'free',
        isPopular: false,
        name: "Artist",
        pricing: "FREE",
        per: "",
        features: [
            "Up to 1 account",
            "Online booking page",
            "Bookings via Instagram/Facebook",
            "Online calendar", "Customer database"
        ],
        desc: ` Try any plan free for 14 days.`,
    },
    {
        id: 'pro',
        isPopular: true,
        name: "Artist Pro",
        pricing: "$9.95",
        per: "/mo",
        features: [
            "Up to 1 account",
            "Online booking page",
            "Bookings via Instagram/Facebook",
            "Online calendar", "Customer database",
            "Business Insights",
            "Email confirmations and reminders",
            "Customer feedback",
            "Google Calendar sync",
        ],
        desc: ` Try any plan free for 14 days.`,
    },
    {
        id: 'enterprise',
        isPopular: false,
        name: "Studio Pro",
        pricing: "$59.95",
        per: "/mo",
        features: [
            "Unlimited accounts",
            "Online booking page",
            "Bookings via Instagram/Facebook",
            "Online calendar", "Customer database",
            "Business Insights",
            "Email confirmations and reminders",
            "Customer feedback",
            "Google Calendar sync",
            "Roles and Permissions",
            "Chat with Clients",
            "Audit activities",
        ],
        desc: ` Try any plan free for 14 days.`,
    },
];


export default function Plans(props: any) {
    const renderPricingItem = (pricing: PricingItem, index: number) => {
        return (
            <div
                key={index}
                className={`h-full relative px-6 py-8 rounded-3xl border-2 flex flex-col overflow-hidden ${
                    pricing.isPopular
                        ? "border-primary-500"
                        : "border-neutral-100 dark:border-neutral-700"
                }`}
            >
                {pricing.isPopular && (
                    <span className="bg-primary-500 text-white px-3 py-1 tracking-widest text-xs absolute right-3 top-3 rounded-full z-10">
            POPULAR
          </span>
                )}
                <div className="mb-8">
                    <h3 className="block text-sm uppercase tracking-widest text-neutral-6000 dark:text-neutral-300 mb-2 font-medium">
                        {pricing.name}
                    </h3>
                    <h2 className="text-5xl leading-none flex items-center">
                        <span>{pricing.pricing}</span>
                        <span className="text-lg ml-1 font-normal text-neutral-500">
              {pricing.per}
            </span>
                    </h2>
                </div>
                <nav className="space-y-4 mb-8">
                    {pricing.features.map((item, index) => (
                        <li className="flex items-center" key={index}>
              <span className="mr-4 inline-flex flex-shrink-0 text-primary-6000">
                <CheckIcon className="w-5 h-5" aria-hidden="true" />
              </span>
                            <span className="text-neutral-700 dark:text-neutral-300">
                {item}
              </span>
                        </li>
                    ))}
                </nav>
                <div className="flex flex-col mt-auto">
                    {pricing.isPopular ? (
                        <ButtonPrimary onClick={() => {
                            props.onSelect(pricing.id)
                        }}>Get Started</ButtonPrimary>
                    ) : (
                        <ButtonSecondary onClick={() => {
                            props.onSelect(pricing.id)
                        }}>
                            <span className="font-medium">Get Started</span>
                        </ButtonSecondary>
                    )}
                    <p className="text-xs text-neutral-500 dark:text-neutral-400 mt-3">
                        {pricing.desc}
                    </p>
                </div>
            </div>
        );
    };

    return (
        <div className="grid lg:grid-cols-3 gap-5 xl:gap-8">
            {pricings.map(renderPricingItem)}
        </div>
    );
}

